export enum InstallType {
    Upgrade,
    Reinstall,
    Downgrade
}

export const InstallTypePastTense = new Map<InstallType, string>([
    [InstallType.Upgrade, 'updated'],
    [InstallType.Reinstall, 'reinstalled'],
    [InstallType.Downgrade, 'downgraded']
]);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/enums/install-type.enum.ts